import { useCallback } from 'react'
import { useAppDispatch } from '@/redux/hooks'
import { enqueueToast } from './slice'
import type { EnqueueToastPayload, ToastDismissMode } from './types'

export const useToast = () => {
  const dispatch = useAppDispatch()

  const push = useCallback(
    (payload: EnqueueToastPayload) => {
      dispatch(enqueueToast(payload))
    },
    [dispatch],
  )

  const error = useCallback(
    (message: string, dismissMode?: ToastDismissMode) => {
      push({ message, severity: 'error', dismissMode })
    },
    [push],
  )

  const success = useCallback(
    (message: string, dismissMode?: ToastDismissMode) => {
      push({ message, severity: 'success', dismissMode })
    },
    [push],
  )

  const info = useCallback(
    (message: string, dismissMode?: ToastDismissMode) => {
      push({ message, severity: 'info', dismissMode })
    },
    [push],
  )

  const warning = useCallback(
    (message: string, dismissMode?: ToastDismissMode) => {
      push({ message, severity: 'warning', dismissMode })
    },
    [push],
  )

  return { push, error, success, info, warning }
}
